import { defineStore } from 'pinia';

import { BiomarkerManager } from './analysis/biomarker-manager-class';

export const useAnalysisStore = defineStore('analysis', {
  state: () => ({
    biomarkerData: null as BiomarkerManager | null,
  }),

  getters: {},
  actions: {
    initBiomarkerContainer() {
      this.biomarkerData = new BiomarkerManager();
      return this.biomarkerData;
    },
    getBiomarkerContainer() {
      if (!this.biomarkerData) {
        this.biomarkerData = new BiomarkerManager();
      }
      return this.biomarkerData;
    },

    isStudyComplete(): boolean {
      if (!this.biomarkerData) return false;
      return this.biomarkerData.isStudyComplete();
    },

    resetStudy() {
      return this.initBiomarkerContainer();
    },
  },
});
